export const rowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  width: '100%',
  textAlign: 'left',
  padding: '8px',
  border: 'none',
  borderRadius: ({ shape }) => shape.radius.l,
  backgroundColor: 'transparent',
  cursor: 'pointer',
  font: 'inherit',
  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },
};

export const nameStyles = {
  color: ({ palette }) => palette.text.primary,
};

export const subtitleStyles = {
  color: ({ palette }) => palette.text.placeholder,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
